<template>
  <div class="inline-flex">
    <label
      v-for="option in options"
      :key="option.value || option"
      class="flex-1 relative"
    >
      <input
        type="radio"
        v-model="toggle"
        :value="option.value || option"
        class="radio-btn absolute opacity-0"
      >
      <span class="label">{{option.label || option}}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ButtonToggle',
  
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
    },
  },

  data() {
    return {
      toggle: null,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler (_value) {
        this.toggle = _value;
      }
    },

    options: {
      immediate: true,
      handler (_options) {
        if (!_options || !_options.length) {
          this.toggle = null;
        
        } else if (
          !this.toggle || !_options.find(option => this.toggle === option || this.toggle === option.value)
        ) {
          this.toggle = _options[0].value || _options[0];
        
        } else {
          this.$emit('change', this.toggle);
        }
      },
    },

    toggle(_value) {
      this.$emit('change', _value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.label {
  @apply .inline-block .cursor-pointer .h-full .px-4 .py-2 .border;
  transition: all .3s;

  &:hover {
    @apply .bg-gray-100 .border-gray-400 .relative;
    z-index: 1;
  }

  .radio-btn:checked +& {
    @apply .bg-gray-200 .relative;
    border-color: $colorLight;
    z-index: 2;
  }
}

.inline-flex > .flex-1 {
  &:first-child .label {
    @apply .rounded-l;
  }

  &:last-child .label {
    @apply .rounded-r;
  }

  +.flex-1 .label {
    @apply .-ml-px;
  }
}
</style>
